import { routes as Home } from '@/views/home/index.js'
import { routes as Scale } from '@/views/scale/index.js'
import { routes as SendedCi } from '@/views/ci/sended/index.js'
import { routes as ReceivedCi } from '@/views/ci/received/index.js'
import { routes as ScalesSwaps } from '@/views/scale/ScaleSwaps/index.js'

export default [
  {
    path: '/',
    name: 'dashboard',
    redirect: '/home',
    component: () => import('./Dashboard.vue'),
    meta: {
      name: 'Dashboard',
      auth: true,
      user: 'Admin',
    },
    children: [...Home, ...Scale, ...SendedCi, ...ReceivedCi, ...ScalesSwaps],
  },
]
